<div class="container" [class.container-fluid]="fluid()" [class.container-fixed]="fixed()">
    <ng-content></ng-content>
</div>
